import script from "./EditCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCompany.vue?vue&type=script&setup=true&lang=js"

import "./EditCompany.vue?vue&type=style&index=0&id=0554e7ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0554e7ea"]])

export default __exports__